import axios from 'axios'

const state = {
        
        farm:{
            name:'',
            owner:'',

        },
        farms: [],
    };

const getters = {
    farmList: state => state.farms
};

const mutations = {
    addNewFarm: (state, farm) => state.farms.unshift(farm),
    removeFarm: (state, farm) => state.farms.shift(farm) 
};

const actions = {
    async fetchFarms({commit}) {
        const response = await axios.get("http://")
    }
};


export default {

    namespaced: true,
    state,
    getters,
    mutations,
    actions
   }
